import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.split.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapActions, mapGetters } from 'vuex';
import logoutAppShop from '@/graphql/seller/logoutAppShop.gql';
import logout from '~/helpers/logout-helper';
export default {
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    sellerName() {
      return this.$cookies.get('MDM_SELLER_USER_NAME');
    },
    formatSellerName() {
      if (this.sellerName && this.sellerName.trim().split(' ').length > 1) {
        var firstName = this.sellerName.split(' ')[0];
        var initial = this.sellerName.split(' ')[1][0];
        return "".concat(firstName, " ").concat(initial, ".");
      }
      return null;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    setSeller: 'seller/setSeller'
  })), {}, {
    goToShop(isLogout) {
      var page = isLogout ? 'login' : 'propositions';
      window.location = "".concat(this.$store.state.sharedEnv.payload.appShopUrl, "/") + "".concat(this.locale.market, "/").concat(this.locale.language, "/") + page;
    },
    handleSellerLogOut() {
      var _this = this;
      return _asyncToGenerator(function* () {
        try {
          yield _this.$apolloProvider.defaultClient.mutate({
            mutation: logoutAppShop
          });
          yield logout(_this.$store);
          _this.setSeller(null);
          window.location = _this.$store.state.sharedEnv.payload.appShopUrl;
          _this.goToShop(true);
        } catch (error) {
          _this.$logger.error("LOGOUT_APP_SHOP_ERROR : ".concat(error));
          _this.$root.$emit('notification', {
            message: _this.$t('error'),
            type: 'error'
          });
        }
      })();
    }
  })
};